export default __webpack_public_path__ + "static/media/GIF1.gif?.b140b660";